import React, { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc, serverTimestamp } from "firebase/firestore/lite";
import styles from "./YourProject.module.scss";
import { storage, db } from "../Firebase"; // Adjust the path if necessary

function YourProject() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    companyName: "",
    website: "",
    country: "",
    description: "",
    agreeToPrivacyPolicy: false,
  });

  const [imageURLs, setImageURLs] = useState([]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleImageUpload = (e) => {
    const files = e.target.files;
    const maxFileSize = 3 * 1024 * 1024; // 3 MB in bytes
    const validFiles = [];

    Array.from(files).forEach((file) => {
      if (file.size > maxFileSize) {
        alert(
          `The file "${file.name}" is too large. Maximum size allowed is 3 MB.`,
        );
      } else {
        validFiles.push(file);
      }
    });

    if (validFiles.length === 0) {
      return; // Stop if no valid files
    }

    const uploadPromises = validFiles.map((file) => {
      const storageRef = ref(storage, `project/anonymous-uploads/${file.name}`);
      return uploadBytes(storageRef, file).then((snapshot) =>
        getDownloadURL(snapshot.ref),
      );
    });

    Promise.all(uploadPromises)
      .then((downloadURLs) => {
        setImageURLs((prevURLs) => [...prevURLs, ...downloadURLs]);
      })
      .catch((error) => {
        console.error("Error uploading files:", error);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.agreeToPrivacyPolicy) {
      alert("You must agree to the privacy policy to submit the form.");
      return;
    }

    try {
      await addDoc(collection(db, "submissions"), {
        ...formData,
        imageURLs,
        submittedAt: serverTimestamp(),
      });
      alert("Form submitted successfully!");
    } catch (error) {
      console.error("Error saving submission:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className={styles.grid}>
      <div className={styles.yourProject}>
        <form onSubmit={handleSubmit}>
          <p className={styles.title}>Your Cork Project</p>

          <div className={styles.item}>
            <label className={styles.label} htmlFor="name">
              Name *
            </label>
            <input
              className={styles.input}
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.item}>
            <label className={styles.label} htmlFor="phone">
              Phone
            </label>
            <input
              className={styles.input}
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.item}>
            <label className={styles.label} htmlFor="email">
              E-Mail *
            </label>
            <input
              className={styles.input}
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.item}>
            <label className={styles.label} htmlFor="companyName">
              Company Name
            </label>
            <input
              className={styles.input}
              type="text"
              id="companyName"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
            />
          </div>

          <div className={styles.item}>
            <label className={styles.label} htmlFor="website">
              Website
            </label>
            <input
              className={styles.input}
              type="url"
              id="website"
              name="website"
              value={formData.website}
              onChange={handleChange}
            />
          </div>

          <div className={`${styles.item} ${styles.special}`}>
            <label className={styles.label} htmlFor="description">
              Description of your project
            </label>
          </div>
          <div className={styles.item}>
            <textarea
              className={styles.textarea}
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <div className={styles.item}>
            <label className={styles.label} htmlFor="attachFiles">
              Attach files..
            </label>
            <div className={styles.fileUpload}>
              <input
                type="file"
                id="attachFiles"
                name="attachFiles"
                onChange={handleImageUpload}
                className={styles.input}
                multiple
              />
              <label htmlFor="attachFiles" className={styles.label}>
                <div className={styles.plusSign}>+</div>
              </label>
            </div>
            {imageURLs.length > 0 && (
              <div className={styles.imagePreviewContainer}>
                {imageURLs.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`Uploaded file ${index + 1}`}
                    className={styles.imagePreview}
                  />
                ))}
              </div>
            )}
          </div>

          <p className={styles.privacyPolicy}>Privacy Policy *</p>
          <div className={`${styles.item} ${styles.addMarginBottom}`}>
            <label className={styles.customCheckboxContainer}>
              <input
                className={styles.input}
                type="checkbox"
                id="agreeToPrivacyPolicy"
                name="agreeToPrivacyPolicy"
                checked={formData.agreeToPrivacyPolicy}
                onChange={handleChange}
                required
              />
              <span
                className={`${styles.checkbox} ${formData.agreeToPrivacyPolicy ? styles.checked : ""}`}
              ></span>
            </label>
            <label
              className={styles.privacyPolicy}
              htmlFor="agreeToPrivacyPolicy"
            >
              I have read and agree to the privacy policy of this website
            </label>
          </div>
          <button className={styles.submit} type="submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default YourProject;
